import React from 'react';

// Types
import { ReferencePatternName } from 'Shared/types/BaInfo.types';

// Components
import ReferencePatternIcon from 'Shared/components/ReferencePatternIcon/ReferencePatternIcon';

import './RelationshipSamplePerson.scss';

type Props = {
  icon: string;
  personFirstName: string;
  personLastName: string;
  referencePatternName: ReferencePatternName;
  referenceProfileDescription: string;
};

const RelationshipSamplePerson = ({
  icon,
  personFirstName,
  personLastName,
  referencePatternName,
  referenceProfileDescription,
}: Props): JSX.Element => {
  const baseClassName = 'RelationshipSamplePerson';

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__profile`}>
        <div className={`${baseClassName}__profile__icon`}>
          {icon && <ReferencePatternIcon referencePattern={referencePatternName} />}
        </div>
        <div className={`${baseClassName}__profile__person`}>
          <div className={`${baseClassName}__profile__person__title`}>SAMPLE</div>
          <span className={`${baseClassName}__profile__person__name`}>{`${personFirstName} ${personLastName}`}</span>
        </div>
      </div>
      <div className={`${baseClassName}__description`}>{referenceProfileDescription}</div>
    </div>
  );
};

export default RelationshipSamplePerson;
